import { baseDriverModel } from '../driverModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = baseDriverModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '司机姓名',
            fieldName: 'driverName',
            span: 3,
        },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
